package fyi.moko.hotpl.ui

actual val isIosPlatform: Boolean = false
actual val platformName: String = "web"
